export default class ExtendedTestController {
  constructor(BoxCaster, EditOrCreateEventService, toaster, $scope, $state, $q) {
    'ngInject';

    this.BoxCaster = BoxCaster;
    this.service = EditOrCreateEventService.getInstance();
    this.boxcasters = [];
    this.getAllBoxCasters();
    this.toaster = toaster;
    this.$scope = $scope;
    this.$state = $state;
    this.$q = $q;

    // Valid extended test durations and a default duration.
    this.DURATIONS = [
      { label: '1 hour', value: 1 * 60 * 60 * 1000 },
      { label: '2 hours', value: 2 * 60 * 60 * 1000 },
      { label: '3 hours', value: 3 * 60 * 60 * 1000 },
      { label: '4 hours', value: 4 * 60 * 60 * 1000 },
      { label: '5 hours', value: 5 * 60 * 60 * 1000 },
      { label: '6 hours', value: 6 * 60 * 60 * 1000 },
      { label: '7 hours', value: 7 * 60 * 60 * 1000 },
      { label: '8 hours', value: 8 * 60 * 60 * 1000 },
    ];
    this.DEFAULT_DURATION = 6 * 60 * 60 * 1000;

    // Offset from "now" for the start time (15 minutes minimum).
    //
    // The API's forecaster looks at the schedule of upcoming broadcasts to know how many servers to
    // keep up, plus some reserve. During off-peak hours when nothing is broadcasting, only the
    // reserve is kept alive, and starting a large number of extended tests at once will completely
    // consume the reserve servers and delay any "real" broadcasts from starting. Since it takes 10-12
    // minutes to bring up new servers, scheduling extended tests 15 minutes in advance gives the API
    // forecaster enough advance warning to bring up the servers needed for these broadcasts, as well
    // as maintain the reserve in case any new (real) broadcasts are added on the fly.
    this.START_OFFSETS = [
      { label: '15 minutes', value: 15 * 60 * 1000 },
      { label: '1 hour', value: 1 * 60 * 60 * 1000 },
      { label: '2 hours', value: 2 * 60 * 60 * 1000 },
      { label: '3 hours', value: 3 * 60 * 60 * 1000 },
      { label: '4 hours', value: 4 * 60 * 60 * 1000 },
      { label: '5 hours', value: 5 * 60 * 60 * 1000 },
      { label: '6 hours', value: 6 * 60 * 60 * 1000 },
      { label: '7 hours', value: 7 * 60 * 60 * 1000 },
      { label: '8 hours', value: 8 * 60 * 60 * 1000 },
    ];
    this.DEFAULT_START_OFFSET = 15 * 60 * 1000;
    this.DEFAULT_AUDIO_BITRATE = 'default';
    this.DEFAULT_VIDEO_BITRATE = 'default';

    this.duration = this.DEFAULT_DURATION;
    this.start_offset = this.DEFAULT_START_OFFSET;
    this.target_video_bitrate = this.DEFAULT_VIDEO_BITRATE;
    this.target_audio_bitrate = this.DEFAULT_AUDIO_BITRATE;
    this.boxcasters_to_test = [];
    this.service.initBroadcast();
    this.service.initScope(this.$scope);
  }

  loadBoxCasters(query) {
    var found = [];
    for (var i = 0; i < this.boxcasters.length; i++) {
      if (this.boxcasters[i].id.indexOf(query) > -1) {
        found.push(this.boxcasters[i]);
      }
    }
    // ensure only boxcasters with the same prefix are loaded
    if (this.boxcasters_to_test && this.boxcasters_to_test.length) {
      found = found.filter((b) => b.id[0] == this.boxcasters_to_test[0].id[0]);
    }
    return found;
  }

  onBoxCasterAdd(tag) {
    this.service.broadcast.boxcaster_id = tag.id;
  }

  submit() {
    const { $q } = this;

    this.submitting = true;
    const startTime = new Date(Date.now() + parseInt(this.start_offset));
    const stopTime = new Date(startTime.getTime() + parseInt(this.duration));

    var promiseChain = this.boxcasters_to_test.reduce((promise, b) => {
      return promise
        .then(() => {
          console.log(`Scheduling extended test for ${b.id}`);
          this.service.initBroadcast();
          this.service.startDate = startTime;
          this.service.startTime = startTime;
          this.service.endTime = stopTime;
          this.service.visibility = 'private';
          this.service.broadcast.boxcaster_id = b.id;
          this.service.broadcast.target_audio_bitrate = this.target_audio_bitrate;
          this.service.broadcast.target_video_bitrate = this.target_video_bitrate;
          this.service.broadcast.name = `Extended ${b.id}`;
          this.service.broadcast.description = `Extended test of ${b.id} from ${startTime} to ${stopTime} using target bitrates
                        ${this.target_video_bitrate} video / ${this.target_audio_bitrate} audio`;
          return this.service.saveChanges();
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    }, $q.when());

    promiseChain
      .then(() => {
        this.toaster.pop({
          type: 'success',
          title: 'Successfully scheduled extended tests',
        });
        this.submitting = false;
        this.$state.go('home');
      })
      .catch((error) => {
        this.toaster.pop({
          type: 'warning',
          title: 'Error scheduling extended tests',
        });
        this.submitting = false;
      });
  }

  getAllBoxCasters() {
    let l = 500;
    let s = 'name';
    let q = 'credentialed:true';
    this.BoxCaster.query({ l: l, s: s, q: q, p: 0 }, (results, headers) => {
      let pagination = JSON.parse(headers('x-pagination'));
      this.boxcasters = this.boxcasters.concat(results);
      for (var p = 1; p <= pagination.last; p++) {
        this.BoxCaster.query({ l: l, s: s, q: q, p: p }, (results) => {
          this.boxcasters = this.boxcasters.concat(results);
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./app/pages/extended-test/extended-test-controller.js